import { handleResponse } from "../_helpers/handle-response";
import {
  authHeader,
  authHeaderAcceptWithJson,
} from "../_helpers/auth-header.js";
import { BASE_URL } from "../_constants/services.constants.js";

const accessoriesManagementService = {
  getModelnSeriesList,
  getAccessorynModelList,
  getAccessorynModelByAccessorylID,
  addAccessorynModel,
  update,
  delete: _delete,
  uploadImage,
};

function getModelnSeriesList() {
  return fetch(`${BASE_URL}/ModelManagement/GetModelnSeriesList`).then(
    handleResponse,
  );
}

function getAccessorynModelList() {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${BASE_URL}/AccessoryManagement/GetAccessorynModelList`,
    requestOptions,
  ).then(handleResponse);
}
function getAccessorynModelByAccessorylID(id) {
  debugger;
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${BASE_URL}/AccessoryManagement/GetAccessorynModelByAccessorylID/` + id,
    requestOptions,
  ).then(handleResponse);
}
function addAccessorynModel(formData) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: authHeaderAcceptWithJson(),
    body: formData,
  };
  return fetch(
    `${BASE_URL}/AccessoryManagement/AddAccessorynModel`,
    requestOptions,
  ).then(handleResponse);
}
function update(formData) {
  const requestOptions = {
    method: "PUT",
    mode: "cors",
    headers: authHeaderAcceptWithJson(),
    body: formData,
  };
  return fetch(
    `${BASE_URL}/AccessoryManagement/UpdateAccessorynModel`,
    requestOptions,
  ).then(handleResponse);
}

function _delete(formData) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
    body: formData,
  };
  return fetch(
    `${BASE_URL}/AccessoryManagement/DeleteAccessorynModel`,
    requestOptions,
  ).then(handleResponse);
}
function uploadImage(formData) {
  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: authHeaderAcceptWithJson(),
    body: formData,
  };
  return fetch(`${BASE_URL}/Uploadfiles/Upload`, requestOptions).then(
    handleResponse,
  );
}
export default accessoriesManagementService;
